__turbopack_context__.v({
  "heading": "DonationFeed-module__1GrAmq__heading",
  "innerContainer": "DonationFeed-module__1GrAmq__innerContainer",
  "wrapper": "DonationFeed-module__1GrAmq__wrapper",
});
